import React from 'react';
import PropTypes from 'prop-types';
import {Flex, Heading, Button, Text} from '@spothero/ui';
import {rightColumnItemStyleProps} from 'pages/parking-pass/styles';
import dayjs from 'utils/dayjs-timezone';

const CallHeroes = ({
    rentalId,
    onTrackedClick,
    phoneNumber = null,
    phoneNumberFormatted = null,
}) => {
    const startTime = dayjs
        .tz('2022-07-29 6:00', 'America/Chicago')
        .tz(dayjs.tz.guess())
        .format('ha');
    const endTime = dayjs
        .tz('2022-07-29 23:00', 'America/Chicago')
        .tz(dayjs.tz.guess())
        .format('ha z');

    const phoneNumberHref = phoneNumber ? phoneNumber : '1-844-243-7768';
    const phoneNumberDisplay = phoneNumberFormatted
        ? phoneNumberFormatted
        : '(844) 243-7768';

    return (
        <Flex backgroundColor="gray.light" {...rightColumnItemStyleProps}>
            <Heading marginBottom={2} fontSize="base" as="h3">
                Questions?
            </Heading>
            <Text marginBottom={3}>Our Customer Heroes are here to help!</Text>
            <Text suppressHydrationWarning marginBottom={3}>
                Available daily, {startTime} &#45; {endTime}
            </Text>
            <Button
                onClick={() =>
                    onTrackedClick({
                        clickTarget: 'Call Heroes',
                        isReservationChange: false,
                    })
                }
                cursor="pointer"
                variant="secondary"
                marginBottom={3}
                as="a"
                href={`tel:${phoneNumberHref}`}
            >
                Call {phoneNumberDisplay}
            </Button>
            <Text fontWeight="semibold" data-testid="CallHeroes-text-rentalid">
                Rental ID: {rentalId}
            </Text>
        </Flex>
    );
};

CallHeroes.propTypes = {
    rentalId: PropTypes.number.isRequired,
    onTrackedClick: PropTypes.func.isRequired,
    phoneNumber: PropTypes.string,
    phoneNumberFormatted: PropTypes.string,
};

export default CallHeroes;
